export const FLOW = {
    ONBOARDING: 'Onboarding',
    ACT60_Eligible: 'Active60Elig',
    ACT60_NOT_Eligible: 'Active60NElig',
}